import { TutorialStep } from "..";

export const InspProjectSteps: TutorialStep[] = [
  {
    target: "#select-ai-server",
    content: "학습 진행시킬 서버를 선택해줍니다.",
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    nextTrigger: "#insp-img-table",
    disableOverlayClose: true,
  },
  {
    target: "#insp-img-table",
    content: "이전의 레이블링하여 정제한 데이터셋을 기준으로 학습/검증 리스트가 자동으로 나뉩니다.",
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#open-train-option",
    content: "클릭하여 학습 옵션을 설정합니다.",
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#defect-preview-modal",
    content: "특정 값을 조절해서 학습에 쓰일 디펙옵션을 설정할 수 있습니다.",
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#train-option",
    content: `학습할 이미지 수와 \n 학습을 반복할 횟수를 지정합니다.\n 현재는 이미지 수: 10, epoch: 2으로 지정해주세요.`,
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    nextTrigger: "#model-save-option",
    disableOverlayClose: true,
  },
  {
    target: "#model-save-option",
    content: `학습/검증 후 저장할 모델의 조건을 설정합니다.`,
    spotlightClicks: false,
    hideFooter: false,
    placement: "bottom",
    disableOverlayClose: true,
  },
  {
    target: "#start-epoch-train",
    content: `적절한 값을 설정했다면 학습을 진행해봅시다.`,
    spotlightClicks: true,
    hideFooter: true,
    placement: "bottom",
    nextTrigger: "#epoch-train-progress",
    disableOverlayClose: true,
  },
];
